import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AddressField } from 'components/AddressField';
import { Dropdown } from 'components/Dropdown/Dropdown';
import { DropdownItem } from 'components/DropdownItem/DropdownItem';
import { OptionalTextArea } from 'components/OptionalTextArea';
import { TextField } from 'components/TextField';
import Typography from 'components/Typography/Typography';
import { useWindowSize } from 'hooks/breakpoints';
import { DELIVERY_ADDRESS_MODAL, DELIVERY_OPTIONS } from 'routes/DeliveryAddressModal/DeliveryAddressModal.const';
import { useDeliveryAddressForm } from 'routes/DeliveryAddressModal/hooks/useDeliveryAddressForm';
import { DeliveryAddressModalSaveCheckbox } from '../Checkbox/DeliveryAddressModalSaveCheckbox';
import styles from './DeliveryAddressModalMain.module.scss';
import { useCustomer } from 'hooks/context/customer/customer';

export const DeliveryAddressModalMain: FC = () => {
  const { t } = useTranslation();
  const { isDesktop } = useWindowSize();
  const { isLoggedIn } = useCustomer();

  const {
    deliveryOption,
    setDeliveryOption,
    mainAddress,
    setMainAddress,
    address2,
    setAddress2,
    deliveryInstructions,
    setDeliveryInstructions,
  } = useDeliveryAddressForm();

  return (
    <div className={styles.formContainer}>
      <AddressField
        data-testid={DELIVERY_ADDRESS_MODAL.addressInput}
        className={styles.formField}
        addressValue={mainAddress}
        onAddressChange={setMainAddress}
      />
      <TextField
        data-testid={DELIVERY_ADDRESS_MODAL.address2Input}
        className={styles.formField}
        label={t('deliveryAddressModal.aptNum')}
        onChange={({ target }) => setAddress2(target.value)}
        value={address2}
      />
      <Dropdown
        data-testid={DELIVERY_ADDRESS_MODAL.preferenceDropdownInput}
        selectClassName={styles.deliveryDropdownSelect}
        readonly={false}
        className={styles.formField}
        label={t('deliveryAddressModal.preference')}
        defaultValue={t(`deliveryAddressModal.${deliveryOption}`)}
      >
        {DELIVERY_OPTIONS.map((item, index) => (
          <DropdownItem key={index} onClick={() => setDeliveryOption(item)} data-testid={item}>
            <Typography.Body bold={deliveryOption === item}>{t(`deliveryAddressModal.${item}`)}</Typography.Body>
          </DropdownItem>
        ))}
      </Dropdown>
      <OptionalTextArea
        data-testid={DELIVERY_ADDRESS_MODAL.specialInstructionsInput}
        buttonClassName={styles.deliveryInstructionsText}
        maxLength={245}
        value={deliveryInstructions}
        onChange={({ target }) => setDeliveryInstructions(target.value)}
      >
        {t('deliveryAddressModal.instructions')}
      </OptionalTextArea>
      {!isDesktop && isLoggedIn && <DeliveryAddressModalSaveCheckbox />}
    </div>
  );
};
